import { render, staticRenderFns } from "./CourierInfoComponent.vue?vue&type=template&id=3d9f7416&scoped=true&"
import script from "./CourierInfoComponent.vue?vue&type=script&lang=js&"
export * from "./CourierInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./CourierInfoComponent.vue?vue&type=style&index=0&id=3d9f7416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9f7416",
  null
  
)

component.options.__file = "CourierInfoComponent.vue"
export default component.exports